module.exports = __webpack_public_path__ + "assets/img/08.fw.e50b53bf.png";